<dsd-link-action type="external" customSrOnly="{{ 'nousJoindre.texteHorsEcran' | translate }}">
  <a
    href="{{ 'nousJoindre.lien' | translate }}"
    id="btnNousJoindre"
    (click)="onClickNousJoindre()"
    >{{ 'nousJoindre.titre' | translate }}</a
  >
</dsd-link-action>
